/**
 * Notification Type Definitions (shared between web and mobile)
 */

export enum NotificationType {
  COMMENT = 'COMMENT',
  REPLY = 'REPLY',
  MENTION = 'MENTION',
  APPROVAL_REQUEST = 'APPROVAL_REQUEST',
  APPROVAL_APPROVED = 'APPROVAL_APPROVED',
  APPROVAL_REJECTED = 'APPROVAL_REJECTED',
  OKR_ASSIGNED = 'OKR_ASSIGNED',
  PROGRESS_UPDATE = 'PROGRESS_UPDATE',
  CHECK_IN_REMINDER = 'CHECK_IN_REMINDER',
  CHECK_IN_SUBMITTED = 'CHECK_IN_SUBMITTED',
  SYSTEM = 'SYSTEM',
}

export interface NotificationCreator {
  id: string;
  firstName: string;
  lastName: string;
  avatar?: string;
}

export interface Notification {
  id: string;
  tenantId: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  isRead: boolean;
  referenceType?: string;
  referenceId?: string;
  actionUrl?: string;
  createdById?: string;
  createdBy?: NotificationCreator;
  createdAt: string;
  readAt?: string;
}

export interface NotificationListResponse {
  notifications: Notification[];
  total: number;
  unreadCount: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface UnreadCountResponse {
  count: number;
}

/**
 * Notification preference per type (for mobile push notification settings)
 */
export interface NotificationPreference {
  notificationType: NotificationType | string;
  pushEnabled: boolean;
  inAppEnabled: boolean;
  emailEnabled: boolean;
}
